import React from 'react';
import { getLoginUrl } from 'services/auth';

interface LoginPageProps {}

const LoginPage: React.FC<LoginPageProps> = (props) => {

    return <a href={getLoginUrl(window.location.href)}>Login with google</a>;
};

export default LoginPage;
